import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media";

const Nav = styled.div`
    position: fixed;
    top: 80px;
    z-index: 100;
    width: 100%;
    left: 0;
    height: 69px;
    text-align: center;
    border-bottom: 1px solid #e1e1e1;
    background: #fff;
    max-width: 100vw;

    ${device.tablet} {
        top: 80px;
        height: 160px;
        border-bottom: 1px solid #bababa;
    }
    ${device.mobile}{
        top: 58px;
        height: 70px;
    }
`;
const List = styled.ul`
    padding-top: 15px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0;
    list-style: none;


    li:not(:first-child) {
        margin-left: 54px;
    }

    ${device.tablet} {
        width: 100%;
        padding-top: 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        li:not(:first-child) {
            margin-left: 0;
        }
    }

    ${device.mobile} {
        padding-top: 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        
        li:not(:first-child) {
            margin-left: 0;
        }
    }

`;
const Item = styled.li`
    display: inline-block;
    transition: all 0.3s;
    color: ${(props) => (props.isActive ? "#362579" : "#4a4a4a")};
    font-weight: ${(props) => (props.isActive ? "bold" : "normal")};
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
    padding: 10px 15px;
    &::after {
        padding-top: 5px;
        content: "";
        display: ${(props) => (props.isActive ? "block" : "none")};
        border-bottom: 1px solid #362579;
    }

    ${device.tablet} {
        width: 25%;
        font-weight: 600;
        height: 70px;
        line-height: 50px;
        font-size: 18px;
        text-align: center;
        box-sizing: border-box;
        padding: 15px 4px;

        &::after {
            margin: 0 40px;
            padding-top: 3px;
            content: "";
            visibility: ${({isActive}) => (isActive ? "visible" : "hidden")};
        }
    }
    ${device.mobile} {
        width: 25%;
        font-size: 14px;
        font-weight: ${(props) => (props.isActive ? "700" : "500")};
        text-align: center;
        box-sizing: border-box;
        height: 35px;
        &::after {
            width: 100%;
            padding-top: 0;
            visibility: ${({isActive}) => (isActive ? "visible" : "hidden")};
        }
    }
`;


const SubNav2 = () => {
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const [path, setPath] = useState("");
    const list = [
        {name: "가이드맵", link: "/map"},
        {name: "박물관", link: "/map/museum"},
        {name: "네이처풀", link: "/map/naturepool"},
        {name: "산책", link: "/map/walkpath"},
        {name: "운동장", link: "/map/playground"},
        {name: "편의시설", link: "/map/facility"},
        {name: "먹거리", link: "/map/foodcourt"},
    ]

    useEffect(() => {
        if (pathname.includes("/map/naturepool")) {
            setPath("/map/naturepool")
        } else {
            setPath(pathname);
        }
    }, [pathname])

    return (
        <Nav>
            <List>
                {list.map((el) => (
                    <Item key={el.name}
                          isActive={el.link === path}
                          onClick={() => navigate(el.link)}
                    >{el.name}
                    </Item>))}
            </List>
        </Nav>
    );
};

export default SubNav2;
